import { QueryFeature } from '../../../config/queryClient';

enum QueryKey {
  TwoFactorAuth = 'TwoFactorAuth',
}

export const queryKeys = {
  TwoFactorAuthSettings: (clientId: string) => [
    QueryFeature.Authentication,
    QueryKey.TwoFactorAuth,
    clientId,
  ],
};
